module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"tooltip":"The chart presents the ranking according to the average availability of offers from the manufacturer\u0027s products per store [% and quantity] in stores displayed in the widget (settings by default). To check the number of offers in other stores, use the shop filter."}}')
  delete Component.options._Ctor
}
